import Swiper, {Navigation, Controller} from "swiper";

const Slider = (element: HTMLElement) =>
	new Swiper(element, {
		modules: [Navigation, Controller],
		direction: "horizontal",
		slidesPerView: "auto",
		allowTouchMove: true,
		spaceBetween: 16,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

export default () => {
	const sliders: HTMLElement[] = Array.from(
		document.querySelectorAll(".block.selection-projects .slider")
	);

	if (!sliders) return;

	sliders.map((element: HTMLElement) => Slider(element));
};
